export default {
    "reference_profile": "Эталонный профиль",
    "profile_1": "Отраслевой профиль",
    "profile_2": "ЭИ-профиль команды",
    "profile_3": "ЭИ-профиль подразделения / направления / компании",
}